// translations/hi.ts
import { TranslationKeys } from '../index';

export const hi: TranslationKeys = {
  header: {
    tutorialButton: "ट्यूटोरियल",
    currentLanguage: "वर्तमान"
  },
  hero: {
    title: "अब सुडोकू बनाम खेलें!",
    description: "एक अद्वितीय सुडोकू चुनौती के लिए तैयार हो जाइए! अकेले अभ्यास का आनंद लें या दोस्तों के खिलाफ मुकाबला करें — अभी डाउनलोड करें और उत्साह का अनुभव करें!",
    howToPlay: "कैसे खेलें",
    googlePlay: {
      topText: "इसे प्राप्त करें",
      bottomText: "Google Play"
    },
    appStore: {
      topText: "इस पर डाउनलोड करें",
      bottomText: "App Store"
    },
    botButtonShow: "मदद चाहिए? हमारे बॉट से पूछें!",
    botButtonHide: "सहायक छिपाएँ"
  },
  footer: {
    followUs: "हमें फॉलो करें",
    handle: "@SUDOKU.VS",
    copyright: "© 2024 सुडोकू बनाम। सर्वाधिकार सुरक्षित।"
  },
  beginnersGuide: {
    modalTitle: "शुरुआती लोगों के लिए गाइड",
    originsTab: "सुडोकू की उत्पत्ति",
    basicsTab: "सुडोकू की मूल बातें",
    rulesTab: "बनाम खेल के नियम",
    origins: {
      bulletOne: "लैटिन वर्गों से प्रेरित; पहली बार 1979 में हॉवर्ड गार्न्स द्वारा प्रकाशित।",
      bulletTwo: "1980 के दशक में जापान में लोकप्रिय हुआ, जिसका नाम बदलकर 'सुडोकू' रखा गया। 2000 के दशक में वैश्विक प्रसिद्धि प्राप्त की।",
      bulletThree: "नौ 3x3 उप-ग्रिड के साथ 9x9 ग्रिड; पंक्तियों, स्तंभों, या उप-ग्रिड में दोहराव के बिना 1 से 9 तक भरें।",
      bulletFour: "लाखों लोगों द्वारा पसंद किया गया, जिसमें कई विविधताएं और नई चुनौतियां हैं।",
      gridSize: {
        four: "4 X 4",
        six: "6 X 6",
        nine: "9 X 9",
      }
    },
    basics: {
      fillMissing: "लापता संख्या भरें!",
      correct: "सही!",
      incorrect: "गलत",
      instructions: "हाइलाइट किए गए स्थान के लिए सही संख्या दर्ज करके 3X3 पहेली को पूरा करें। प्रत्येक पंक्ति, स्तंभ और बॉक्स में प्रत्येक संख्या ठीक एक बार होनी चाहिए। सही संख्या का चयन करें। बुद्धिमानी से चुनें!",
      feedbackCorrect: "आपने अपना पहला बॉक्स हल कर लिया!",
      feedbackIncorrect: "पुनः प्रयास करें!",
      basicsStep2: {
        instructions: "हाइलाइट किए गए स्थान के लिए सही संख्या का चयन करके 4X4 पहेली को पूरा करें। प्रत्येक पंक्ति, स्तंभ और बॉक्स में प्रत्येक संख्या ठीक एक बार होनी चाहिए। सही संख्या का चयन करें। बुद्धिमानी से चुनें!",
        feedbackCorrect: "आप बहुत अच्छा कर रहे हैं!"
      },
      basicsStep3: {
        instructions: "हाइलाइट किए गए स्थान के लिए सही संख्या का चयन करके 4X4 पहेली को पूरा करें। प्रत्येक पंक्ति, स्तंभ और बॉक्स में प्रत्येक संख्या ठीक एक बार होनी चाहिए। सही संख्या का चयन करें। बुद्धिमानी से चुनें!",
        feedbackCorrect: "उत्तम समाधान!",
        feedbackIncorrect: "गलत - पुनः प्रयास करें!"
      },
      congratulations: {
        title: "बधाई हो!",
        subtitle: "आपने सुडोकू की मूल बातें ट्यूटोरियल सफलतापूर्वक पूरा कर लिया है! आपके समर्पण और प्रयास का फल मिला है, और अब आप आत्मविश्वास के साथ सुडोकू पहेली से निपटने के लिए आवश्यक कौशल से लैस हैं।",
        nextStepsTitle: "अगले कदम",
        nextStepsText: "अब अपने कौशल का परीक्षण करने का समय है! आज ही सुडोकू गेम डाउनलोड करें और विभिन्न पहेलियों में डूब जाएं। चाहे आप एक त्वरित एकल गेम पसंद करते हों या कुछ दोस्ताना प्रतिस्पर्धा में शामिल होना चाहते हों, आप एकल मोड में या एक प्रतिद्वंद्वी के खिलाफ बनाम मोड में खेलना चुन सकते हैं।",
        ctaHeader: "एक खेल के लिए तैयार हैं?",
        ctaHighlight: "अभी डाउनलोड करें!",
        rulesTitle: "खेल के नियमों में महारत हासिल करें",
        rulesText: "खेल में कूदने से पहले, सुडोकू बनाम: खेल के नियम देखना सुनिश्चित करें। नियमों और अंक प्रणाली को समझने से आपको विरोधियों के खिलाफ खेलते समय एक फायदा मिल सकता है। यह ज्ञान आपके अनुभव को बढ़ाएगा और आपको प्रभावी ढंग से रणनीति बनाने में मदद करेगा!"
      }
    },
    gameRules: {
      notification: {
        important: "महत्वपूर्ण: ",
        text: "सर्वश्रेष्ठ अनुभव के लिए सूचनाएं सक्षम करें!"
      },
      rulesHeader: "नियम",
      rulesList: {
        rule1_pre: "एक ",
        rule1_strong: "दोस्ताना या यादृच्छिक मैच",
        rule1_post: " आमंत्रण स्वीकार करें या बनाएं।",
        rule2_pre: "खिलाड़ी को ",
        rule2_strong: "पहले जाने के लिए यादृच्छिक रूप से चुना जाता है।",
        rule3: "बोर्ड पूरा होने तक खिलाड़ी बारी-बारी से खेलते हैं।",
        rule4_pre1: "प्रत्येक ",
        rule4_strong1: "बारी 60 सेकंड तक चलती है,",
        rule4_pre2: " प्रति बारी ",
        rule4_strong2: "5 संख्याओं की सीमा के साथ।",
        rule5_pre: "प्रति बारी केवल ",
        rule5_strong: "1 संकेत",
        rule5_post: " की अनुमति है।",
        rule6_pre: "सबसे ",
        rule6_strong: "अधिक अंक वाला खिलाड़ी",
        rule6_post: " खेल जीतता है।",
        rule7_pre: "एक ",
        rule7_strong_pre: "टाई",
        rule7_pre2: " की स्थिति में, अधिक इनपुट वाला खिलाड़ी ",
        rule7_strong_post: "खेल",
        rule7_post: " जीतता है।",
        rule8: "यदि आप 24 घंटों के भीतर अपनी बारी समाप्त नहीं करते हैं, तो आप स्वचालित रूप से खेल हार जाते हैं।"
      },
      rulesWarning: "24 घंटे में अपनी बारी खेलें अन्यथा आप स्वचालित रूप से खेल हार जाएंगे",
      gameControls: {
        header: "खेल नियंत्रण",
        list: {
          control1_pre: "खेल को छोड़ने के लिए ",
          control1_strong: "समर्पण ध्वज",
          control1_post: " का उपयोग करें।",
          control2_pre: "गलती को सुधारने के लिए ",
          control2_strong: "इरेज़र",
          control2_post: " का उपयोग करें।",
          control3_pre: "यदि आपने टाइमर समाप्त होने से पहले अपने सभी इनपुट पूरे कर लिए हैं तो ",
          control3_strong: "बारी समाप्त करें",
          control3_post: " का उपयोग करें।"
        }
      },
      scoring: {
        header: "स्कोरिंग",
        list: {
          score1_pre1: "सही संख्या प्लेसमेंट के लिए ",
          score1_strong1: "1 अंक",
          score1_pre2: " अर्जित करें।",
          score1_span: "सही",
          score1_post: "",
          score2_pre1: "प्रत्येक गलत संख्या प्लेसमेंट के लिए ",
          score2_strong1: "1 अंक",
          score2_pre2: " खो दें।",
          score2_span: "गलत",
          score2_post: "",
          score3_pre1: "प्रत्येक हल की गई पंक्ति, स्तंभ और बॉक्स के लिए ",
          score3_strong1: "5 अंक",
          score3_pre2: " अर्जित करें।",
          score3_span: "हल",
          score3_post: ""
        }
      },
    },
    controller: {
      previous: "पिछला",
      of: " का ",
      close: "बंद करें",
      next: "अगला",
      gameRules: "खेल के नियम",
    },
  },
  tutorials: {
    modalTitle: "ट्यूटोरियल",
    tabs: {
      introduction: "परिचय",
      gettingStarted: "शुरुआत करना",
      vsFriends: "दोस्तों के खिलाफ",
      howToPlay: "कैसे खेलें",
    },
    messages: {
      loading: "ट्यूटोरियल लोड हो रहे हैं...",
      error: "ट्यूटोरियल लोड करने में त्रुटि:",
      fallback: "फालबैक डेटा का उपयोग किया जा रहा है...",
      empty: "इस खंड के लिए कोई ट्यूटोरियल उपलब्ध नहीं है।",
    },
  },
  cookieConsent: {
    title: "सहमति प्राथमिकताएँ प्रबंधित करें",
    description: "हम आपके सुडोकू बनाम अनुभव को बढ़ाने, हमारे ट्रैफ़िक का विश्लेषण करने और व्यक्तिगत विज्ञापन प्रदान करने के लिए कुकीज़ का उपयोग करते हैं।",
    acceptAll: "सभी कुकीज़ स्वीकार करें",
    confirmChoices: "विकल्पों की पुष्टि करें",
    performance: {
      title: "प्रदर्शन कुकीज़",
      description: "हमें उपयोग विश्लेषण के माध्यम से हमारे खेल और सेवाओं को बेहतर बनाने के लिए डेटा एकत्र करने की अनुमति देता है।"
    },
    advertising: {
      title: "विज्ञापन",
      adStorage: "आपके डिवाइस पर विज्ञापन डेटा के भंडारण की अनुमति देता है",
      adMeasurement: "विज्ञापन माप के लिए डेटा एकत्र करने की अनुमति देता है",
      adPersonalization: "हमें आपकी रुचियों के आधार पर आपको व्यक्तिगत विज्ञापन दिखाने की अनुमति देता है"
    },
    landing: {
        title: "कुकी सूचना",
        description: "हम आपके सुडोकू बनाम अनुभव को बढ़ाने, हमारे ट्रैफ़िक का विश्लेषण करने और व्यक्तिगत विज्ञापन प्रदान करने के लिए कुकीज़ का उपयोग करते हैं। जारी रखने से पहले आप यह निर्धारित कर सकते हैं कि आप किन कुकीज़ को अनुमति देना चाहते हैं।",
        acceptAll: "सभी कुकीज़ स्वीकार करें",
        customizeSettings: "सेटिंग्स अनुकूलित करें",
        fineprint: "\"सभी कुकीज़ स्वीकार करें\" पर क्लिक करके, आप सहमत हैं कि<br />सुडोकू बनाम आपके डिवाइस पर कुकीज़ संग्रहीत कर सकता है"
    }
  },
languages: {
    en: "English",
    es: "Español", 
    fr: "Français",
    hi: "हिन्दी",
    bn: "বাংলা",
    pt: "Português",
    it: "Italiano",
    ru: "Русский",
    ja: "日本語",
    ko: "한국어"
},
  privacyPolicy: {
    modalTitle: "गोपनीयता नीति",
    sections: {
      introduction: {
        title: "1. परिचय",
        p1: "सुडोकू बनाम में आपका स्वागत है। हम आपकी गोपनीयता की रक्षा करने और यह सुनिश्चित करने के लिए प्रतिबद्ध हैं कि आपकी हमारी वेबसाइट पर सकारात्मक अनुभव हो। यह गोपनीयता नीति बताती है कि हम आपकी सुडोकू गेम प्लेटफॉर्म का उपयोग करते समय आपकी जानकारी कैसे एकत्र, उपयोग और सुरक्षित करते हैं।",
        p2: "सुडोकू बनाम का उपयोग करके, आप इस नीति के अनुसार जानकारी के संग्रह और उपयोग से सहमत होते हैं।"
      },
      informationWeCollect: {
        title: "2. जानकारी जो हम एकत्र करते हैं",
        p1: "हम अपनी सेवाएं प्रदान करने और सुधारने के लिए विभिन्न प्रकार की जानकारी एकत्र करते हैं:",
        list: {
          usageData: "उपयोग डेटा: हम स्वचालित रूप से जानकारी एकत्र करते हैं कि आप हमारे गेम के साथ कैसे इंटरैक्ट करते हैं, जिसमें गेमप्ले सांख्यिकी, पहेली पूरा करने का समय, खेले गए कठिनाई स्तर और गेम प्राथमिकताएं शामिल हैं।",
          deviceInfo: "डिवाइस जानकारी: हम उस डिवाइस के बारे में जानकारी एकत्र कर सकते हैं जिसका उपयोग आप सुडोकू बनाम तक पहुंचने के लिए करते हैं, जिसमें डिवाइस प्रकार, ब्राउज़र प्रकार, आईपी पता और ऑपरेटिंग सिस्टम शामिल है।",
          cookies: "कुकीज़ और ट्रैकिंग डेटा: हम आपके अनुभव को बेहतर बनाने और विश्लेषिकी डेटा एकत्र करने के लिए कुकीज़ और समान ट्रैकिंग तकनीकों का उपयोग करते हैं।"
        }
      },
      howWeUseInfo: {
        title: "3. हम आपकी जानकारी का उपयोग कैसे करते हैं",
        p1: "हम एकत्र की गई जानकारी का उपयोग निम्नलिखित उद्देश्यों के लिए करते हैं:",
        list: {
          gameImprovement: "गेम सुधार: गेमप्ले पैटर्न का विश्लेषण करने और हमारी सुडोकू पहेलियों, कठिनाई एल्गोरिदम और समग्र उपयोगकर्ता अनुभव में सुधार करने के लिए।",
          performanceAnalytics: "प्रदर्शन विश्लेषिकी: उपयोग रुझानों की निगरानी और विश्लेषण करने, हमारी सेवाओं की प्रभावशीलता को मापने और सुधार के क्षेत्रों की पहचान करने के लिए।",
          personalization: "व्यक्तिगतकरण: आपकी खेल प्राथमिकताओं के आधार पर आपको व्यक्तिगत गेम सिफारिशें और अनुकूलित सामग्री प्रदान करने के लिए।",
          technicalSupport: "तकनीकी सहायता: मुद्दों का निवारण करने, बग्स को ठीक करने और हमारे प्लेटफॉर्म के सुचारू संचालन को सुनिश्चित करने के लिए।"
        }
      },
      cookies: {
        title: "4. कुकीज़ और ट्रैकिंग तकनीकें",
        p1: "सुडोकू बनाम आपके अनुभव को बेहतर बनाने के लिए कुकीज़ का उपयोग करता है। आपके पास अपनी कुकी प्राथमिकताओं को प्रबंधित करने का विकल्प है:",
        performanceCookies: {
          title: "प्रदर्शन कुकीज़:",
          description: "ये कुकीज़ हमें उपयोग विश्लेषिकी के माध्यम से हमारे गेम और सेवाओं को बेहतर बनाने के लिए डेटा एकत्र करने की अनुमति देती हैं। वे हमें यह समझने में मदद करती हैं कि खिलाड़ी हमारी पहेलियों के साथ कैसे इंटरैक्ट करते हैं, कौन सी सुविधाएं सबसे लोकप्रिय हैं और हम कहां सुधार कर सकते हैं। यह डेटा गेमप्ले को बेहतर बनाने और बेहतर सुडोकू अनुभव बनाने के लिए आवश्यक है।"
        },
        advertisingCookies: {
          title: "विज्ञापन कुकीज़:",
          list: [
            "आपके डिवाइस पर विज्ञापन डेटा के भंडारण की अनुमति देती हैं",
            "विज्ञापन माप और प्रभावशीलता के लिए डेटा संग्रह सक्षम करती हैं",
            "हमें आपकी रुचियों और गेमिंग व्यवहार के आधार पर आपको व्यक्तिगत विज्ञापन दिखाने की अनुमति देती हैं"
          ]
        },
        p2: "आप कुकी सहमति बैनर के माध्यम से अपनी कुकी प्राथमिकताओं को नियंत्रित कर सकते हैं जो आपकी वेबसाइट पर पहली बार आने पर दिखाई देता है। आप अपनी ब्राउज़र सेटिंग्स के माध्यम से किसी भी समय अपनी सेटिंग्स बदल सकते हैं, हालांकि कुछ कुकीज़ को अक्षम करने से वेबसाइट की कार्यक्षमता प्रभावित हो सकती है।"
      },
      thirdParty: {
        title: "5. तृतीय-पक्ष सेवाएं",
        p1: "सुडोकू बनाम निम्नलिखित तृतीय-पक्ष सेवाओं के साथ एकीकृत होता है:",
        gemini: {
          title: "गूगल जेमिनी एआई सहायक:",
          description: "हमारा सहायता बॉट गूगल जेमिनी द्वारा संचालित है जिसमें गेम-संबंधित प्रश्नों में आपकी सहायता करने, सुडोकू युक्तियाँ प्रदान करने और मुद्दों के निवारण में मदद करने के लिए एक अंतर्निहित ज्ञान आधार है। जब आप बॉट के साथ इंटरैक्ट करते हैं, तो आपकी क्वेरीज़ गूगल की सिस्टम द्वारा प्रोसेस की जा सकती हैं। कृपया डेटा को कैसे हैंडल करते हैं इसकी जानकारी के लिए गूगल की गोपनीयता नीति देखें।"
        },
        youtube: {
          title: "यूट्यूब एम्बेडेड वीडियो:",
          description: "हम ट्यूटोरियल सामग्री और गेमप्ले गाइड सीधे हमारी वेबसाइट के भीतर प्रदान करने के लिए यूट्यूब वीडियो ओवरले का उपयोग करते हैं। जब आप इन वीडियो के साथ इंटरैक्ट करते हैं, तो यूट्यूब उनकी गोपनीयता नीति के अनुसार डेटा एकत्र कर सकता है। आप सुडोकू बनाम छोड़े बिना वीडियो देख सकते हैं, लेकिन यूट्यूब की ट्रैकिंग मैकेनिज्म अभी भी लागू हो सकती है।"
        },
        advertising: {
          title: "विज्ञापन भागीदार:",
          description: "हम अपने प्लेटफॉर्म पर विज्ञापन प्रदर्शित करने के लिए तृतीय-पक्ष विज्ञापन भागीदारों के साथ काम करते हैं। ये भागीदार व्यक्तिगत विज्ञापन उद्देश्यों के लिए आपकी ब्राउज़िंग गतिविधि के बारे में जानकारी एकत्र करने के लिए कुकीज़ और समान तकनीकों का उपयोग कर सकते हैं।"
        }
      },
      dataSecurity: {
        title: "6. डेटा सुरक्षा",
        p1: "हम आपके डेटा की सुरक्षा को गंभीरता से लेते हैं और अनधिकृत पहुंच, परिवर्तन, प्रकटीकरण या विनाश के खिलाफ आपकी जानकारी की रक्षा के लिए उपयुक्त तकनीकी और संगठनात्मक उपाय लागू करते हैं। हालांकि, कृपया ध्यान दें कि इंटरनेट पर ट्रांसमिशन या इलेक्ट्रॉनिक स्टोरेज की कोई विधि 100% सुरक्षित नहीं है।",
        p2: "हमारी वेबसाइट उद्योग-मानक सुरक्षा प्रोटोकॉल का उपयोग करती है और एक सुरक्षित ब्राउज़िंग अनुभव सुनिश्चित करने के लिए गोडैडी सुरक्षा मुहर द्वारा सत्यापित है।"
      },
      privacyRights: {
        title: "7. आपके गोपनीयता अधिकार",
        p1: "आपकी व्यक्तिगत जानकारी के संबंध में आपके कुछ अधिकार हैं:",
        list: {
          access: "पहुंच: आप उस डेटा के बारे में जानकारी का अनुरोध कर सकते हैं जो हमारे पास आपके बारे में है",
          correction: "सुधार: आप गलत जानकारी के सुधार का अनुरोध कर सकते हैं",
          deletion: "हटाना: आप कानूनी दायित्वों के अधीन, अपने डेटा के विलोपन का अनुरोध कर सकते हैं",
          optOut: "ऑप्ट-आउट: आप अपनी कुकी प्राथमिकताओं के माध्यम से व्यक्तिगत विज्ञापन से ऑप्ट आउट कर सकते हैं",
          portability: "डेटा पोर्टेबिलिटी: आप पोर्टेबल प्रारूप में अपने डेटा की एक प्रति का अनुरोध कर सकते हैं"
        }
      },
      childrenPrivacy: {
        title: "8. बच्चों की गोपनीयता",
        p1: "सुडोकू बनाम सामान्य दर्शकों के लिए डिज़ाइन किया गया है। हम जानबूझकर 13 वर्ष से कम उम्र के बच्चों से व्यक्तिगत जानकारी एकत्र नहीं करते हैं। यदि आप माता-पिता या अभिभावक हैं और मानते हैं कि आपके बच्चे ने हमें व्यक्तिगत जानकारी प्रदान की है, तो कृपया हमसे संपर्क करें ताकि हम उचित कार्रवाई कर सकें।"
      },
      changes: {
        title: "9. इस गोपनीयता नीति में परिवर्तन",
        p1: "हम अपनी प्रथाओं में परिवर्तन या कानूनी, परिचालन, या नियामक कारणों से इस गोपनीयता नीति को समय-समय पर अपडेट कर सकते हैं। हम इस पृष्ठ पर नई गोपनीयता नीति पोस्ट करके और नीचे \"अंतिम अद्यतन\" तिथि अपडेट करके आपको किसी भी महत्वपूर्ण परिवर्तन के बारे में सूचित करेंगे।",
        p2: "हम आपको इस गोपनीयता नीति की समीक्षा समय-समय पर करने के लिए प्रोत्साहित करते हैं ताकि आप यह जानते रहें कि हम आपकी जानकारी की रक्षा कैसे करते हैं।"
      },
      contact: {
        title: "10. हमसे संपर्क करें",
        p1: "यदि आपके पास इस गोपनीयता नीति या हमारी डेटा प्रथाओं के संबंध में कोई प्रश्न, चिंता या अनुरोध है, तो कृपया हमसे संपर्क करें:",
        email: "ईमेल: privacy@sudoku.vs",
        website: "वेबसाइट: www.sudoku.vs",
        p2: "हम आपकी पूछताछ का जल्द से जल्द जवाब देंगे।"
      }
    },
    footer: {
      lastUpdated: "अंतिम अद्यतन: 10 अक्टूबर 2025",
      effectiveDate: "प्रभावी तिथि: 10 अक्टूबर 2025"
    }
  },
  copywright: {
    text: 'कॉपीराइट © 2025 सॉफ्टवेयर आर्किटेक्ट्स लिमिटेड। सर्वाधिकार सुरक्षित।'
  }
};